import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { MasterContextProvider }   from "./contexts/MasterContext";
import { AnalyticsContextProvider } from "./contexts/AnalyticsContext";
import { NavigationContextProvider } from "./contexts/NavigationContext";

/* Master Components */
import Ticker         from "./components/Ticker";
import Header         from "./components/Header";
import Footer         from "./components/Footer";

import Transitory     from "./pages/Transitory";
import Card           from "./pages/Card"; 
import NineEightyThree from "./pages/983";

/* Components */
import Revolution     from "./pages/Revolution";
import CowJuice       from "./components/CowJuice";

/* Helpers */
import Scroller       from "./pages/Scroller";
import Error          from "./pages/Error";

import Home        from "./pages/Home";

/* Static */
import Retorted       from "./pages/Retorted";
import Press          from "./pages/Press";
import Questions      from "./pages/Questions";
import Contact        from "./pages/Contact";
import QR             from "./pages/QR";

/* Legal */
import Terms          from "./pages/legal/Terms";   
import Privacy        from "./pages/legal/Privacy";
import Cookies        from "./pages/legal/Cookies";

/* Checkout */
import ContactEntry        from "./pages/checkouts/ContactEntry";
import Payment             from "./pages/checkouts/Payment";

// import Status         from "./pages/orders/Status";

import Products        from "./pages/shopify/Products";
import ProductDetails  from "./pages/shopify/ProductDetails";
import Bag             from "./pages/shopify/Bag";

/* Orders i.e., post-payment, order-placement handling */
import Confirmation from "./pages/orders/Confirmation";
import Status       from "./pages/orders/Status";

import Reviews      from "./pages/Reviews";

const App = () => (
  <Router>
    <MasterContextProvider>
        <NavigationContextProvider>
        <AnalyticsContextProvider>
          <Scroller />   {/* helper component to catch all navs & scroll to top of each newly navigated to page */}
          <div class="bg-white text-black dark:bg-black dark:text-white overflow-hidden">
    
            {/* ─────────────── all non-checkout pages ─────────────── */}
            <Routes>
              <Route
                path="*"
                element={
                  <div class="flex flex-col min-h-screen p-4 space-y-4">
                    <Error />
                  </div>
                }
              />
              {/* <Route
                path="/"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Ticker />
                    <Header />
                    <Transitory />
                    <Footer />
                  </div>
                }
              /> */}

              {/* ---------- storefront ---------- */}
              <Route
                path="/"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Ticker />
                    <Header />
                    <CowJuice />
                    <Home />
                    <Retorted />
                    <Questions />
                    <Revolution />
                    <Footer />
                  </div>
                }
              />

              {/* ---------- static ---------- */}
              <Route
                path="/ultra-retorted-milk"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Ticker />
                    <Header />
                    <Retorted />
                    <Footer />
                  </div>
                }
              />
              <Route
                path="/the-revolution-of-cow-juice"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Ticker />
                    <Header />
                    <Revolution />
                    <Footer />
                  </div>
                }
              />
              <Route
                path="/press"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Ticker />
                    <Header />
                    <Press />
                    <Footer />
                  </div>
                }
              />
              <Route
                path="/questions"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Ticker />
                    <Header />
                    <Questions />
                    <Footer />
                  </div>
                }
              />
              <Route
                path="/contact"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Ticker />
                    <Header />
                    <Contact />
                    <Footer />
                  </div>
                }
              />
              <Route
                path="/qr"
                element={
                  <div class="flex flex-col min-h-screen p-0 space-y-4">
                    <QR />
                  </div>
                }
              />
              <Route
                path="/the-most-retorted-milk-on-earth"
                element={
                  <div class="flex flex-col min-h-screen p-0 space-y-4">
                    <Card />
                  </div>
                }
              />
              <Route
                path="/983"
                element={
                  <div class="flex flex-col min-h-screen p-0 space-y-4">
                    <NineEightyThree />
                  </div>
                }
              />


              {/* ---------- checkout, payment handling ---------- */}
              <Route 
                path={`/checkouts/:checkoutId/contact-entry/:consumptionCharacterization`}
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Header />
                    <ContactEntry />
                    <Footer />
                  </div>
                }
              />
              
              <Route 
                path="/checkouts/:checkoutId/payment/:paymentId"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Header />
                    <Payment />
                    <Footer />
                  </div>
                }
              />

              {/* ---------- order, post-payment handling ---------- */}
              <Route
                path="/orders/:orderId/confirmation"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Header />
                    <Confirmation />
                    <Footer />
                  </div>
                }
              />
              <Route 
                path="/orders/status/:confirmationNumber?"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Header />
                    <Status />
                    <Footer />
                  </div>
                }
              />

              {/* ---------- shopify reliant pages (i.e., our custom built shopify store) ---------- */}
              <Route 
                path="/shopify/products"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Header />
                    <Products />
                    <Footer />
                  </div>
                }
              />
              <Route 
                path="/shopify/products/:productId"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Header />
                    <ProductDetails />
                    <Footer />
                  </div>
                }
              />
              <Route 
                path="/shopify/bag"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Header />
                    <Bag />
                    <Footer />
                  </div>
                }
              />

              <Route 
                path="/beta/reviews"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Ticker />
                    <Header />
                    <Reviews />
                    <Footer />
                  </div>
                }
              />

              <Route 
                path="/legal/terms-and-conditions"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Ticker />
                    <Header />
                    <Terms />
                    <Footer />
                  </div>
                }
              />
              <Route 
                path="/legal/privacy-policy"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Ticker />
                    <Header />
                    <Privacy />
                    <Footer />
                  </div>
                }
              />

              <Route 
                path="/legal/cookies"
                element={
                  <div class="flex flex-col min-h-screen p-0">
                    <Ticker />
                    <Header />
                    <Cookies />
                    <Footer />
                  </div>
                }
              />

            </Routes>
          </div>
        </AnalyticsContextProvider>
      </NavigationContextProvider>
    </MasterContextProvider>
  </Router>
);

export default App;
